import { CHART_COLORS } from '@/lib/constants';

export const CHART_CONFIG = {
  defaults: {
    height: 300,
    margin: { top: 20, right: 20, bottom: 20, left: 20 },
    radius: [4, 4, 0, 0],
    gridDasharray: '3 3',
  },
  colors: CHART_COLORS,
  tooltip: {
    contentStyle: {
      backgroundColor: 'var(--background)',
      border: '1px solid var(--border)',
      borderRadius: '4px',
      padding: '8px',
    },
  },
} as const;